{
  "zh-CN": {
    "number": {
      "format": {
        "precision": 2,
        "strip_insignificant_zeros": true,
        "delimiter": ".",
        "separator": ","
      },
      "units": {
        "au": "AU",
        "uec": "aUEC",
        "currency": "$",
        "uecPerUnit": "aUEC / Unit",
        "distance": "m",
        "weight": "t",
        "speed": "m/s",
        "cargo": "SCU",
        "person": "人",
        "people": {
          "one": "人",
          "other": "人"
        }
      },
      "uec": "%{count} <span class=\"text-muted\">aUEC</span>",
      "uecPerUnit": "%{count} <span class=\"text-muted\">aUEC/unit</span>",
      "percent": "%{count} %",
      "distance": "%{count} m",
      "newton": "%{count} KN",
      "thrust": "%{count} KN",
      "weight": "%{count} t",
      "speed": "%{count} m/s",
      "acceleration": "%{count} m/s²",
      "seconds": "%{count} s",
      "milliseconds": "%{count} ms",
      "rateOfFire": "%{count} shots/min",
      "rotation": "%{count} deg/s",
      "degrees": "%{count}°",
      "zoom": "%{count}×",
      "cargo": "%{count} SCU",
      "integer": "%{count}",
      "dps": "%{count} DPS",
      "damage": "%{count} DMG",
      "shieldHp": "%{count} HP",
      "shieldRegen": "%{count}s 回复",
      "coolingRate": "%{count} 冷却速率",
      "powerOutput": "%{count} 输出",
      "powerPips": "%{count} 档",
      "driveSpeed": "%{count} km/s",
      "weaponRange": "%{count} m",
      "weaponSpeed": "%{count} m/s",
      "missileRange": "%{count} m",
      "missileSpeed": "%{count} m/s",
      "lockTime": "%{count}s",
      "regenTime": "%{count}s",
      "delayTime": "%{count}s",
      "spoolTime": "%{count}s",
      "cooldownTime": "%{count}s",
      "fuelRate": "%{count}",
      "fuelFlow": "%{count} µSCU/s",
      "aimAssistRange": "%{count} m",
      "fuel": "%{count}",
      "ships": {
        "one": "%{count} 飞船",
        "other": "%{count} 飞船"
      },
      "people": {
        "one": "%{count} 人",
        "other": "%{count} 人"
      },
      "rem": "%{count} REM",
      "remPerSecond": "%{count} REM/s",
      "microScu": "%{count} µSCU"
    }
  }
}
